class OrganizationResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { contentApi }) {
        return headers =>
            $resource(
                `${contentApi.url}/v1/organizations/:id`,
                { id: "@id" },
                {
                    get: {
                        method: "GET",
                        headers: headers || {}
                    },
                    update: {
                        method: "PATCH",
                        headers: headers || {}
                    },
                    setMedia: {
                        method: "POST",
                        url: `${contentApi.url}/v1/organizations/:id/medias`
                    },
                    getMedias: {
                        method: "GET",
                        isArray: true,
                        url: `${contentApi.url}/v1/organizations/:id/medias`
                    },
                    deleteMedia: {
                        method: "DELETE",
                        url: `${contentApi.url}/v1/organizations_medias/:id`
                    },
                    setAsAdvertiser: {
                        method: "POST",
                        url: `${contentApi.url}/v1/organizations/:id/membership/to-advertiser`
                    },
                    setAsMember: {
                        method: "POST",
                        url: `${contentApi.url}/v1/organizations/:id/membership/to-member`
                    }
                }
            );
    }
}

angular.module("thor.core.organization.resource", []).factory("organizationResource", OrganizationResource);
